import { useMutation } from "@tanstack/react-query";
import { postHprVerifyAadhaarOtp } from "apis";

const usePostHprVerifyAadhaarOtp = () => {
  return useMutation(postHprVerifyAadhaarOtp);
};

export default usePostHprVerifyAadhaarOtp;
